import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import useFiltersFetchedData from '../../../../helperHooks/useFiltersFetchedData';
import { Category, CategoryRaw } from '../../../../types';
import { CATEGORIES_API_CACHE_KEY } from '../../../../constants';
import { API_V1_HOSTNAME_KEY } from '../../../../localStorageKeys';
import { ProductCreateEdit } from '../helpers/types';
import { ApiContext } from '../../../../context/ApiContext';

const useProducts = () => {
  const { t } = useTranslation();
  const { apiFetch } = useContext(ApiContext);
  const queryClient = useQueryClient();
  const [productsAddedSuccessMessage, setProductsAddedSuccessMessage] = useState('');

  const {
    isLoading: isAddingProducts,
    mutate: addProducts,
    isError: errorAddingProducts,
  } = useMutation(
    (newProducts: ProductCreateEdit[]) =>
      apiFetch(
        `${localStorage.getItem(API_V1_HOSTNAME_KEY)}onboarding/proxy/products`,
        newProducts,
        'POST'
      ),
    {
      onSuccess(_response) {
        queryClient.invalidateQueries(['products']);
        setProductsAddedSuccessMessage(t('screens.products.sidekick.import.productsAdded'));
      },
    }
  );

  return {
    isAddingProducts,
    addProducts,
    errorAddingProducts,
    productsAddedSuccessMessage,
    setProductsAddedSuccessMessage,
  };
};

export default useProducts;
